export default __webpack_public_path__ + "static/media/landworks.520e1cf2.svg";